module.exports = __webpack_public_path__ + "img/photocasescanImei.ef3033fe.png";